import { useEffect } from "react";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function ContattiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="contatti-page" className="pt-20">
      <Contact />
      <Footer />
    </main>
  );
}
